import {
  AccountsApi,
  Configuration,
  type CriiptoTokenLoginRequest,
  type CriiptoTokenLoginResponse,
} from '@trinnvis/dabih-api-client';

export async function criiptoLogin(requestParameters: CriiptoTokenLoginRequest): Promise<CriiptoTokenLoginResponse> {
  console.log('criiptoLogin - Request parameters:', JSON.stringify(requestParameters, null, 2));

  const config = new Configuration({ fetchApi: fetch });
  const api = new AccountsApi(config);

  try {
    console.log('criiptoLogin - Calling API endpoint...');
    const response = await api.criiptoTokenLogin(requestParameters);
    console.log('criiptoLogin - API response received:', JSON.stringify(response, null, 2));
    return response;
  } catch (error: any) {
    console.error('criiptoLogin - API call failed:', error);
    if (error?.response) {
      let errorData;
      try {
        errorData = await error.response.text();
      } catch {
        errorData = 'Could not read error response';
      }
      console.error('criiptoLogin - Error response details:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: errorData,
        headers: error.response.headers,
        url: error.response.url,
      });
    }
    throw error;
  }
}
